module.exports = __webpack_public_path__ + "img/Imagen 31@2x.1a9b6d83.png";